/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  Error,
  EslogExportByDateRange,
  EslogExportByDocumentIds,
  ExportDocumentsParams,
  ExportSalesPerItemParams,
  GetEslogExportStatus200,
  GetPdfExportStatus200,
  PdfExportByDateRange,
  PdfExportByDocumentIds,
  StartEslogExport202,
  StartPdfExport202
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Export filtered documents to Excel (XLSX) or CSV format.
Supports date range filtering (maximum 1 year) and the same query filters as list endpoints.
Returns a downloadable file with all base document fields including flattened customer/issuer data and tax breakdowns.
 * @summary Export documents to Excel or CSV
 */
export type exportDocumentsResponse200ApplicationVndOpenxmlformatsOfficedocumentSpreadsheetmlSheet = {
  data: Blob
  status: 200
}

export type exportDocumentsResponse200TextCsv = {
  data: Blob
  status: 200
}

export type exportDocumentsResponse400 = {
  data: Error
  status: 400
}

export type exportDocumentsResponse401 = {
  data: Error
  status: 401
}

export type exportDocumentsResponse403 = {
  data: Error
  status: 403
}

export type exportDocumentsResponse404 = {
  data: Error
  status: 404
}

export type exportDocumentsResponse500 = {
  data: Error
  status: 500
}

export type exportDocumentsResponseSuccess = (exportDocumentsResponse200ApplicationVndOpenxmlformatsOfficedocumentSpreadsheetmlSheet | exportDocumentsResponse200TextCsv) & {
  headers: Headers;
};
export type exportDocumentsResponseError = (exportDocumentsResponse400 | exportDocumentsResponse401 | exportDocumentsResponse403 | exportDocumentsResponse404 | exportDocumentsResponse500) & {
  headers: Headers;
};

export type exportDocumentsResponse = (exportDocumentsResponseSuccess | exportDocumentsResponseError)

export const getExportDocumentsUrl = (params: ExportDocumentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/documents/export?${stringifiedParams}` : `/documents/export`
}

export const exportDocuments = async (params: ExportDocumentsParams, options?: RequestInit): Promise<exportDocumentsResponse> => {
  
  return customFetch<exportDocumentsResponse>(getExportDocumentsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Export aggregated sales data per item (product/service) for a given date range.
Includes quantities sold/returned, average price, and totals.
Aggregates across invoices, credit notes, and advance invoices.
Items are grouped by catalog item ID when available, or by exact name match.
 * @summary Export sales per item for a period
 */
export type exportSalesPerItemResponse200ApplicationVndOpenxmlformatsOfficedocumentSpreadsheetmlSheet = {
  data: Blob
  status: 200
}

export type exportSalesPerItemResponse200TextCsv = {
  data: Blob
  status: 200
}

export type exportSalesPerItemResponse400 = {
  data: Error
  status: 400
}

export type exportSalesPerItemResponse401 = {
  data: Error
  status: 401
}

export type exportSalesPerItemResponse403 = {
  data: Error
  status: 403
}

export type exportSalesPerItemResponse404 = {
  data: Error
  status: 404
}

export type exportSalesPerItemResponse500 = {
  data: Error
  status: 500
}

export type exportSalesPerItemResponseSuccess = (exportSalesPerItemResponse200ApplicationVndOpenxmlformatsOfficedocumentSpreadsheetmlSheet | exportSalesPerItemResponse200TextCsv) & {
  headers: Headers;
};
export type exportSalesPerItemResponseError = (exportSalesPerItemResponse400 | exportSalesPerItemResponse401 | exportSalesPerItemResponse403 | exportSalesPerItemResponse404 | exportSalesPerItemResponse500) & {
  headers: Headers;
};

export type exportSalesPerItemResponse = (exportSalesPerItemResponseSuccess | exportSalesPerItemResponseError)

export const getExportSalesPerItemUrl = (params: ExportSalesPerItemParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/documents/export/sales-per-item?${stringifiedParams}` : `/documents/export/sales-per-item`
}

export const exportSalesPerItem = async (params: ExportSalesPerItemParams, options?: RequestInit): Promise<exportSalesPerItemResponse> => {
  
  return customFetch<exportSalesPerItemResponse>(getExportSalesPerItemUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Start a background job to export documents as a ZIP archive of PDFs.
Supports date range filtering (maximum 1 year) or specific document IDs.
When using a user access token, you will receive an email with a download link when the export is ready.
When using an API key, poll the job status endpoint for progress.
 * @summary Start bulk PDF export
 */
export type startPdfExportResponse202 = {
  data: StartPdfExport202
  status: 202
}

export type startPdfExportResponse400 = {
  data: Error
  status: 400
}

export type startPdfExportResponse401 = {
  data: Error
  status: 401
}

export type startPdfExportResponse403 = {
  data: Error
  status: 403
}

export type startPdfExportResponse404 = {
  data: Error
  status: 404
}

export type startPdfExportResponse500 = {
  data: Error
  status: 500
}

export type startPdfExportResponseSuccess = (startPdfExportResponse202) & {
  headers: Headers;
};
export type startPdfExportResponseError = (startPdfExportResponse400 | startPdfExportResponse401 | startPdfExportResponse403 | startPdfExportResponse404 | startPdfExportResponse500) & {
  headers: Headers;
};

export type startPdfExportResponse = (startPdfExportResponseSuccess | startPdfExportResponseError)

export const getStartPdfExportUrl = () => {


  

  return `/documents/export/pdf`
}

export const startPdfExport = async (pdfExportByDocumentIdsPdfExportByDateRange: PdfExportByDocumentIds | PdfExportByDateRange, options?: RequestInit): Promise<startPdfExportResponse> => {
  
  return customFetch<startPdfExportResponse>(getStartPdfExportUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      pdfExportByDocumentIdsPdfExportByDateRange,)
  }
);}
  

/**
 * Check the status and progress of a bulk PDF export job.
 * @summary Get PDF export job status
 */
export type getPdfExportStatusResponse200 = {
  data: GetPdfExportStatus200
  status: 200
}

export type getPdfExportStatusResponse400 = {
  data: Error
  status: 400
}

export type getPdfExportStatusResponse401 = {
  data: Error
  status: 401
}

export type getPdfExportStatusResponse403 = {
  data: Error
  status: 403
}

export type getPdfExportStatusResponse404 = {
  data: Error
  status: 404
}

export type getPdfExportStatusResponse500 = {
  data: Error
  status: 500
}

export type getPdfExportStatusResponseSuccess = (getPdfExportStatusResponse200) & {
  headers: Headers;
};
export type getPdfExportStatusResponseError = (getPdfExportStatusResponse400 | getPdfExportStatusResponse401 | getPdfExportStatusResponse403 | getPdfExportStatusResponse404 | getPdfExportStatusResponse500) & {
  headers: Headers;
};

export type getPdfExportStatusResponse = (getPdfExportStatusResponseSuccess | getPdfExportStatusResponseError)

export const getGetPdfExportStatusUrl = (jobId: string,) => {


  

  return `/documents/export/pdf/${jobId}`
}

export const getPdfExportStatus = async (jobId: string, options?: RequestInit): Promise<getPdfExportStatusResponse> => {
  
  return customFetch<getPdfExportStatusResponse>(getGetPdfExportStatusUrl(jobId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Download a completed PDF export ZIP archive through the authenticated API.
 * @summary Download completed PDF export archive
 */
export type downloadPdfExportResponse200 = {
  data: Blob
  status: 200
}

export type downloadPdfExportResponse400 = {
  data: Error
  status: 400
}

export type downloadPdfExportResponse401 = {
  data: Error
  status: 401
}

export type downloadPdfExportResponse403 = {
  data: Error
  status: 403
}

export type downloadPdfExportResponse404 = {
  data: Error
  status: 404
}

export type downloadPdfExportResponse500 = {
  data: Error
  status: 500
}

export type downloadPdfExportResponseSuccess = (downloadPdfExportResponse200) & {
  headers: Headers;
};
export type downloadPdfExportResponseError = (downloadPdfExportResponse400 | downloadPdfExportResponse401 | downloadPdfExportResponse403 | downloadPdfExportResponse404 | downloadPdfExportResponse500) & {
  headers: Headers;
};

export type downloadPdfExportResponse = (downloadPdfExportResponseSuccess | downloadPdfExportResponseError)

export const getDownloadPdfExportUrl = (jobId: string,) => {


  

  return `/documents/export/pdf/${jobId}/download`
}

export const downloadPdfExport = async (jobId: string, options?: RequestInit): Promise<downloadPdfExportResponse> => {
  
  return customFetch<downloadPdfExportResponse>(getDownloadPdfExportUrl(jobId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Start a background job to export valid e-SLOG XML documents as a ZIP archive.
Supports date range filtering (maximum 1 year) or specific document IDs.
Only available for Slovenian entities with e-SLOG support.
Documents without valid e-SLOG validation are skipped.
 * @summary Start bulk e-SLOG export
 */
export type startEslogExportResponse202 = {
  data: StartEslogExport202
  status: 202
}

export type startEslogExportResponse400 = {
  data: Error
  status: 400
}

export type startEslogExportResponse401 = {
  data: Error
  status: 401
}

export type startEslogExportResponse403 = {
  data: Error
  status: 403
}

export type startEslogExportResponse404 = {
  data: Error
  status: 404
}

export type startEslogExportResponse422 = {
  data: Error
  status: 422
}

export type startEslogExportResponse500 = {
  data: Error
  status: 500
}

export type startEslogExportResponseSuccess = (startEslogExportResponse202) & {
  headers: Headers;
};
export type startEslogExportResponseError = (startEslogExportResponse400 | startEslogExportResponse401 | startEslogExportResponse403 | startEslogExportResponse404 | startEslogExportResponse422 | startEslogExportResponse500) & {
  headers: Headers;
};

export type startEslogExportResponse = (startEslogExportResponseSuccess | startEslogExportResponseError)

export const getStartEslogExportUrl = () => {


  

  return `/documents/export/eslog`
}

export const startEslogExport = async (eslogExportByDocumentIdsEslogExportByDateRange: EslogExportByDocumentIds | EslogExportByDateRange, options?: RequestInit): Promise<startEslogExportResponse> => {
  
  return customFetch<startEslogExportResponse>(getStartEslogExportUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      eslogExportByDocumentIdsEslogExportByDateRange,)
  }
);}
  

/**
 * Check the status and progress of a bulk e-SLOG export job.
 * @summary Get e-SLOG export job status
 */
export type getEslogExportStatusResponse200 = {
  data: GetEslogExportStatus200
  status: 200
}

export type getEslogExportStatusResponse400 = {
  data: Error
  status: 400
}

export type getEslogExportStatusResponse401 = {
  data: Error
  status: 401
}

export type getEslogExportStatusResponse403 = {
  data: Error
  status: 403
}

export type getEslogExportStatusResponse404 = {
  data: Error
  status: 404
}

export type getEslogExportStatusResponse500 = {
  data: Error
  status: 500
}

export type getEslogExportStatusResponseSuccess = (getEslogExportStatusResponse200) & {
  headers: Headers;
};
export type getEslogExportStatusResponseError = (getEslogExportStatusResponse400 | getEslogExportStatusResponse401 | getEslogExportStatusResponse403 | getEslogExportStatusResponse404 | getEslogExportStatusResponse500) & {
  headers: Headers;
};

export type getEslogExportStatusResponse = (getEslogExportStatusResponseSuccess | getEslogExportStatusResponseError)

export const getGetEslogExportStatusUrl = (jobId: string,) => {


  

  return `/documents/export/eslog/${jobId}`
}

export const getEslogExportStatus = async (jobId: string, options?: RequestInit): Promise<getEslogExportStatusResponse> => {
  
  return customFetch<getEslogExportStatusResponse>(getGetEslogExportStatusUrl(jobId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Download a completed e-SLOG export ZIP archive through the authenticated API.
 * @summary Download completed e-SLOG export archive
 */
export type downloadEslogExportResponse200 = {
  data: Blob
  status: 200
}

export type downloadEslogExportResponse400 = {
  data: Error
  status: 400
}

export type downloadEslogExportResponse401 = {
  data: Error
  status: 401
}

export type downloadEslogExportResponse403 = {
  data: Error
  status: 403
}

export type downloadEslogExportResponse404 = {
  data: Error
  status: 404
}

export type downloadEslogExportResponse500 = {
  data: Error
  status: 500
}

export type downloadEslogExportResponseSuccess = (downloadEslogExportResponse200) & {
  headers: Headers;
};
export type downloadEslogExportResponseError = (downloadEslogExportResponse400 | downloadEslogExportResponse401 | downloadEslogExportResponse403 | downloadEslogExportResponse404 | downloadEslogExportResponse500) & {
  headers: Headers;
};

export type downloadEslogExportResponse = (downloadEslogExportResponseSuccess | downloadEslogExportResponseError)

export const getDownloadEslogExportUrl = (jobId: string,) => {


  

  return `/documents/export/eslog/${jobId}/download`
}

export const downloadEslogExport = async (jobId: string, options?: RequestInit): Promise<downloadEslogExportResponse> => {
  
  return customFetch<downloadEslogExportResponse>(getDownloadEslogExportUrl(jobId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

